module.exports = __webpack_public_path__ + "media/img/astronauto-d0c7e42a.png";